// extracted by mini-css-extract-plugin
export var fadeInOut = "_3w-3";
export var icon = "_3w-4";
export var savedIndicator = "_3w-2";
export var savingIndicator = "_3w-0";
export var spin = "_3w-1";